module.exports = __webpack_public_path__ + "img/danger-sign.817b4a3a.svg";